"use client";

import type { CSSProperties } from "react";
import { Toaster } from "sonner";
import { useRenderedTheme } from "@/hooks/use-app-theme";

const TOAST_COLORS: CSSProperties & Record<`--${string}`, string> = {
  "--normal-bg": "var(--popover)",
  "--normal-bg-hover": "var(--accent)",
  "--normal-border": "var(--border)",
  "--normal-border-hover": "var(--border-strong)",
  "--normal-text": "var(--popover-foreground)",
  "--success-text": "var(--success-strong)",
  "--info-text": "var(--info-strong)",
  "--warning-text": "var(--warning-strong)",
  "--error-text": "var(--destructive-strong)",
  "--toast-close-button-start": "unset",
  "--toast-close-button-end": "0",
  "--toast-close-button-transform": "translate(35%, -35%)",
};

export function AppToaster() {
  const theme = useRenderedTheme();

  return (
    <Toaster
      theme={theme}
      richColors
      closeButton
      position="top-right"
      style={TOAST_COLORS}
      toastOptions={{
        classNames: {
          toast:
            "rounded-lg border border-border bg-background text-foreground shadow-md",
          title: "text-sm font-medium",
          description: "text-xs text-muted-foreground",
        },
      }}
    />
  );
}
